// extracted by mini-css-extract-plugin
module.exports = {"icon":"Notice_icon__2trvN","paragraph":"Notice_paragraph__3SpbN"};